import React, { useState } from 'react';
import copy from 'copy-to-clipboard';
import { useAtom } from 'jotai';
import { useToast, Icon, Text } from '@pairy/pds-react';

import { GOOGLE_EVENT_ID } from '../../../../../../constant/googleEventId';
import { UserFileInfoType } from '../../../../../../types/file';
import useFileHistoryShare from '../../../../../../hooks/mutation/file/useFileHistoryShare';
import { useViewerRoute } from '../../../../../../contexts/ViewerRoute';
import { isDisableHelpersAtom } from '../../../../../../store/index.atom';

import * as Styled from './index.styles';

interface Props {
  domain?: UserFileInfoType['domain'];
  translateKoToEn: (item: string) => string;
  isBulk: boolean;
}

const DesktopShareButton = ({
  domain,
  translateKoToEn,
  isBulk = false,
}: Props) => {
  const { historyId, getShareUrl } = useViewerRoute();
  const toast = useToast();

  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  const [isDisableHelpers, setIsDisableHelpers] = useAtom(isDisableHelpersAtom);

  const { mutate: mutateFileHistoryShare } = useFileHistoryShare(isBulk);

  const handleClickLinkCopyButton = (
    e: React.MouseEvent<HTMLButtonElement>,
  ) => {
    e.stopPropagation();

    if (isDisableHelpers) {
      setIsDisableHelpers(false);
      return;
    }

    copy(getShareUrl({ domain, isBulk }));

    mutateFileHistoryShare({
      historyId,
    });

    toast(`${translateKoToEn('link-copy')}`);
  };

  return (
    <Styled.Button
      id={GOOGLE_EVENT_ID.share}
      className={isDisableHelpers ? 'disable' : ''}
      variant="zinc_500"
      textVariant="xl-medium"
      radius={9999}
      paddingY={16}
      onClick={handleClickLinkCopyButton}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      leftIcon={<Icon icon="ph:share-network" size={19} color="black" />}
    >
      {isHovering && (
        <Text
          id={GOOGLE_EVENT_ID.share}
          variant="lg-medium"
          marginLeft={8}
          style={{
            whiteSpace: 'nowrap',
          }}
        >
          {translateKoToEn('share')}
        </Text>
      )}
    </Styled.Button>
  );
};

export default DesktopShareButton;
